import { HeroNextArrow } from '@/components/HeaderHero/Slider/HeroNextArrow';
import { HeroPrevArrow } from '@/components/HeaderHero/Slider/HeroPrevArrow';

export const sliderSettings = {
  accessibility: true,
  focusOnSelect: true,
  dots: true,
  arrows: true,
  infinite: true,
  nextArrow: HeroNextArrow,
  prevArrow: HeroPrevArrow,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: true,
  autoplay: true,
  autoplaySpeed: 5000,
  interval: 5000,
  centerMode: true,
  centerPadding: 0,
};
